import {Injectable} from '@angular/core';
import {GridModel} from "../grid/grid.model";
import {Observable} from "rxjs";

@Injectable()
export class GridService {
 url: string;
 getData: Function;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/services/grid.service.ts